import { atom } from "recoil";

export const selectParameterButtonState = atom({
  key: "selectParameterButtonState",
  default: {},
});
